<template>
  <div class="product-links" v-if="links && links.length">
    <div class="product-links__inner">
      <product-link v-for="(link, index) in links" :id="'p-' + link.id" :link="link" :key="index" />
    </div>
  </div>
</template>

<script>
  import ProductLink from '~/components/product/ProductLink.vue';

  export default {
    components: {
      ProductLink
    },
    props: {
      links: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
